import React, {Component} from 'react';
import TrackVisibility from 'react-on-screen';
import {ArrowUp, Instagram} from './Icons';
import animateScrollTo from 'animated-scroll-to';
import './Footer.css';


class Footer extends Component {

  constructor(props){
    super(props);
    this.animateToTop = this.animateToTop.bind(this);
  }

  animateToTop(){
    animateScrollTo(0, {speed: 300});
  }

  render(){
    let {instragram} = this.props;
    return(
      <TrackVisibility partialVisibility>
        {({ isVisible }) => (
          <div className={`Footer ${isVisible ? 'Footer-visible' : ''}`}>
            <div className="Footer-button" onClick={this.animateToTop}>
              <ArrowUp />
            </div>
            <div className="Footer-button">
              <a target="_blank" rel="noopener noreferrer" href={instragram.url}>
                <Instagram />
              </a>
            </div>
          </div>
        )}
      </TrackVisibility>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js